import { SearchIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Kbd } from "@/components/ui/kbd";
import { cn } from "@/lib/utils";

import { PALETTE_SHORTCUT } from "./palette-shortcut";

interface SearchButtonProps {
  onClick: () => void;
  className?: string;
}

/** "Search… ⌘K" pill that opens the command palette. */
export function SearchButton({ onClick, className }: SearchButtonProps) {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      aria-keyshortcuts={PALETTE_SHORTCUT.aria}
      className={cn("h-[34px] w-64 justify-start px-3 font-normal text-muted-foreground lg:w-80", className)}
    >
      Search courses and pages
      <Kbd className="ml-auto">{PALETTE_SHORTCUT.label}</Kbd>
    </Button>
  );
}

/** Icon-only variant for narrow screens. */
export function SearchIconButton({ onClick, className }: SearchButtonProps) {
  return (
    <Button
      variant="ghost"
      size="icon-sm"
      onClick={onClick}
      aria-label="Search"
      aria-keyshortcuts={PALETTE_SHORTCUT.aria}
      className={className}
    >
      <SearchIcon />
    </Button>
  );
}
